<template>
  <div class="content_main">
    <div class="content_main_top">
      <a-select
        placeholder="所属流程"
        allowClear
        show-search
        :filter-option="filterOption"
        class="a_input_self margin_self"
        v-model="queryParam.procDefKey"
        @keyup.enter.native="serch"
      >
        <a-select-option :value="item.id" v-for="(item, index) in Approvallist" :key="index">
          {{ item.name }}
        </a-select-option>
      </a-select>
      <a-select
        placeholder="状态"
        allowClear
        class="a_input_self margin_self"
        v-model="queryParam.status"
        default-value="0"
        @keyup.enter.native="serch"
      >
        <a-select-option :value="''">全部</a-select-option>
        <a-select-option v-for="(val, key) in status_apply" :key="key" :value="key">{{ val.txt }} </a-select-option>
      </a-select>
      <a-select
        placeholder="审批结果"
        allowClear
        class="a_input_self margin_self"
        v-model="queryParam.result"
        default-value="0"
        @keyup.enter.native="serch"
      >
        <a-select-option :value="''">全部</a-select-option>
        <a-select-option v-for="(val, key) in result_apply" :key="key" :value="key">{{ val.txt }} </a-select-option>
      </a-select>
      <a-input
        placeholder="审批编号"
        allowClear
        v-model="queryParam.applyCode"
        class="a_input_self margin_self"
        @keyup.enter.native="serch"
      />

      <a-select
        class="a_input_self margin_self"
        allowClear
        placeholder="请选择公司"
        v-model="queryParam.companyId"
        @change="handlecompanyplan"
      >
        <a-select-option :value="item.value" v-for="(item, index) in companylist" :key="index">
          {{ item.title }}
        </a-select-option>
      </a-select>
      <a-tree-select
        class="a_input_self margin_self"
        allowClear
        :treeData="deptTree"
        placeholder="请选择"
        :disabled="!this.queryParam.companyId"
        v-model="queryParam.deptId"
      >
      </a-tree-select>
      <a-input
        placeholder="申请标题"
        allowClear
        v-model="queryParam.title"
        class="a_input_self margin_self"
        @keyup.enter.native="serch"
      />
      <a-input
        placeholder="申请金额"
        allowClear
        v-model="queryParam.amount"
        oninput="value=value.match(/\d+\.?\d{0,2}/,'')"
        class="a_input_self margin_self"
        @keyup.enter.native="serch"
      />
       <a-input
        placeholder="当前审批环节"
        allowClear
        v-model="queryParam.currentTask"
        class="a_input_self margin_self"
        @keyup.enter.native="serch"
      />
      <a-range-picker
        valueFormat="YYYY-MM-DD"
        style="margin-right: 10px; width: 240px"
        allowClear
        :value="dates"
        @change="onChange"
        :placeholder="['申请开始时间', '申请结束时间']"
        @keyup.enter.native="serch"
      />
      <!-- <a-select show-search allowClear placeholder="公司" class="margin_self" @change="handlecompany" v-model="queryParam.companyId"
			 @keyup.enter.native="serch" style="width: 120px">
				<a-select-option :value="item.dept_id" v-for="(item, index) in companylist" :key="index">
					{{ item.dept_name }}
				</a-select-option>
			</a-select>
			<a-tree-select allowClear :treeData="deptTree" v-model="queryParam.deptId" :disabled="!queryParam.companyId"
			 placeholder="部门" @keyup.enter.native="serch" class="margin_self" style="width: 170px"
			 treeDefaultExpandAll>
			</a-tree-select> -->
      <a-button type="primary" style="margin: 5px" @click="serch"> 查询 </a-button>
      <a-button type="primary" ghost @click="result"> 重置 </a-button>
    </div>
    <div class="content_main_center_scroll" id="content_main_center_scroll">
      <a-table
        :data-source="data"
        bordered
        :scroll="{ y: scroll_y }"
        :pagination="pagination"
        @change="handleTableChange"
      >
        <a-table-column key="index" title="序号" data-index="index" width="70px">
          <template scope="text, record, index">{{ (pagination.current - 1) * 10 + index + 1 }}</template>
        </a-table-column>
        <a-table-column key="applyCode" width="250px" ellipsis="true" title="审批编号" data-index="applyCode" />
        <a-table-column key="title" width="250px" ellipsis="true" title="申请标题" data-index="title" />
        <a-table-column key="procName" ellipsis="true" title="所属流程" data-index="procName" />
        <a-table-column key="currentTask" ellipsis="true" title="当前审批环节" data-index="currentTask" />
        <a-table-column key="auditors" ellipsis="true" title="当前审批人" data-index="auditors" />
        <a-table-column key="amount" ellipsis="true" title="金额" data-index="amount" width="80px" />
        <a-table-column key="comment" ellipsis="true" title="审批意见" data-index="comment" />
        <a-table-column key="result" ellipsis="true" title="审批结果" data-index="result">
          <template scope="text">
            <span class="tag_class" :style="{ background: result_apply[text].color }">
              {{ result_apply[text].txt }}
            </span>
          </template>
        </a-table-column>
        <a-table-column key="status" ellipsis="true" title="状态" data-index="status">
          <template scope="text">
            <span class="tag_class" :style="{ background: status_apply[text].color }">
              {{ status_apply[text].txt }}
            </span>
          </template>
        </a-table-column>
        <a-table-column key="applyTime" ellipsis="true" title="申请时间" data-index="applyTime" />
        <a-table-column key="action" title="操作" data-index="action" width="160px">
          <template scope="text,record">
            <a @click="handelAuditone(record)">详情</a>
            <a-divider type="vertical" />
						<a @click="handFlow(record)">历史</a>
            <a-divider type="vertical" />
            <a :disabled="record.status !== 1" @click="cancel([record.procInstId])">撤销</a>
            <a-divider v-if="$store.getters.userInfo.userId == 1" :disabled="record.status === 1"  type="vertical" />
            <a v-if="$store.getters.userInfo.userId == 1" :disabled="record.status === 1" @click="delByIds([record.id])"
              >删除</a
            >
          </template>
        </a-table-column>
      </a-table>
    </div>
    <a-modal title="详情" :visible="detailsvisible" @cancel="detailsvisible = false" width="55%">
      <template slot="footer">
        <a-button key="back" @click="detailsvisible = false"> 取消 </a-button>
      </template>
      <a-form-model :model="detailsrow" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="物品编号">
              <span>{{ detailsrow.spu_sn }}</span>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="物品名称">
              <span>{{ detailsrow.name }}</span>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="规格型号">
              <span>{{ detailsrow.model }}</span>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="物品数量">
              <span>{{ detailsrow.amount }}</span>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="物品单价">
              <span>{{ detailsrow.price }}</span>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="物品单位">
              <span>{{ detailsrow.unit }}</span>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="资产类别">
              <span>{{ detailsrow.spu_type_name }}</span>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="是否已检定">
              <span>{{ instrumentMap[detailsrow.is_inspected] }}</span>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="公司名称">
              <span>{{ detailsrow.company_name }}</span>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="备注">
              <span>{{ detailsrow.notes }}</span>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="是否为制毒、制爆">
              <span
                ><span>{{
                  detailsrow.hazard_type ? detailsrow.hazard_type.replace('其他;', '').replace(/;/g, '、') : ''
                }}</span></span
              >
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="存放条件">
              <span>{{
                detailsrow.storage_cond ? detailsrow.storage_cond.replace('其他;', '').replace(/;/g, '、') : ''
              }}</span>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-modal>
    <!-- 撤销提示 -->
    <a-modal v-model="is_revocation" title="确认撤销此申请吗?" on-ok="handleOkReason">
      <template slot="footer">
        <a-button key="back" @click="is_revocation = false"> 取消 </a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleOkReason"> 撤销 </a-button>
      </template>
      <a-textarea placeholder="请输入原因" v-model="reason" />
    </a-modal>
    <business-modal ref="modal" @ok="handleOk" />
    <leave-modal ref="leavemodal" @ok="handleOk" :audit="false" />
    <purchase-modal ref="purchasemodal" @ok="handleOk" :audit="false" />
    <scrap-modal ref="scrapmodal" @ok="handleOk" :audit="false" />
    <receive-modal ref="receiveModal" @ok="handleOk" :audit="false" />
    <operation-modal ref="operationmodal" @ok="handleOk" :audit="false" />
    <service-modal ref="servicemodal" @ok="handleOk" :audit="false" />
    <reimbursement-modal ref="reimbursementmodal" @ok="handleOk" :audit="false" />
    <!-- 详情 -->
    <payMentModal ref="paymentmodal" :audit="false" />
    <!-- 详情 -->
    <contractModal ref="contractmodal" :audit="false" />
    <transferModal ref="transferModal" @sure="handleSure" />
    <sealModal ref="sealmodal" @ok="handleOk" :audit="false" />
    <currencyModal ref="currencymodal" @ok="handleOk" :audit="false" />
    <returnModal ref="returnmodal" @ok="handleOk" :audit="false" />
    <car-modal ref="carmodal" @ok="handleOk" :audit="false" />
    <returncar-modal ref="returncarmodal" @ok="handleOk" :audit="false" />
    <salaryModal ref="salarymodal" @ok="handleOk" :audit="false" />
    <adjustmentModal ref="adjustmentmodal" @ok="handleOk" :audit="false" />
    <charge-modal ref="chargemodal" @ok="handleOk" :audit="false" />
    <other-modal ref="othermodal" @ok="handleOk" :audit="false" />
    <feedback-modal ref="feedbackmodal" @ok="handleOk" :audit="false" />
    <inventory-modal ref="inventorymodal" @ok="handleOk" :audit="false" />
    <proc-flow-modal ref="modalflow" @ok="handleOk" />
    <newPaymentModel ref="newPaymentModel"></newPaymentModel>
    <salaryEditModal ref="salaryEditModal" :audit="false"></salaryEditModal>
    <quotation ref="quotation" :audit="false"></quotation>
    <contractReview ref="contractReview" :audit="false"></contractReview>
    <tender ref="tender" :audit="false"></tender>
	  <contractDetail ref="contractDetail"  :audit="false"></contractDetail>
    <terminationModal ref="terminationModal"  :audit="false"></terminationModal>


  </div>
</template>

<script>
import salaryEditModal from './modules/salaryEditModal.vue'
import debounce from 'lodash/debounce'
import { getDeptListEnable2 } from '@/api/system'
import { audit_list } from '@/api/financial'
import { purchase_save, business_list_all, tree_all } from '@/api/purchase'
import {
  claim_apply,
  getDeptListEnable,
  dict,
  // get_dept_tree,
} from '@/api/assetmenag'
import { delProcessIns, modalMap, delBusiness } from '@/api/activiti'
import { get_dict, returnDept2, get_users } from '@/utils/unit_axios'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import BusinessModal from '@/views/activiti/modules/BusinessModal.vue'
import ProcFlowModal from './modules/ProcFlowModal.vue' //历史
import LeaveModal from '@/views/activiti/modules/LeaveModal.vue'
import PurchaseModal from '@/views/activiti/modules/PurchaseModal.vue'
import ScrapModal from '@/views/activiti/modules/ScrapModal.vue'
import receiveModal from '@/views/activiti/modules/receiveModal.vue'
import OperationModal from '@/views/activiti/modules/OperationModal.vue'
import ServiceModal from '@/views/activiti/modules/ServiceModal.vue'
import ReimbursementModal from '@/views/activiti/modules/ReimbursementModal.vue'
import payMentModal from '@/views/activiti/modules/payMentModal.vue'
import contractModal from '@/views/activiti/modules/contractModal.vue'
import transferModal from '@/views/activiti/modules/TransferModal.vue'
import sealModal from '@/views/activiti/modules/sealModal.vue'
import currencyModal from '@/views/activiti/modules/currencyModal.vue'
import returnModal from '@/views/activiti/modules/returnModal.vue'
import carModal from '@/views/activiti/modules/carModal.vue'
import returncarModal from '@/views/activiti/modules/returncarModal.vue'
import salaryModal from '@/views/activiti/modules/salaryModal.vue'
import adjustmentModal from '@/views/activiti/modules/adjustmentModal.vue'
import chargeModal from '@/views/activiti/modules/chargeModal.vue'
import otherModal from '@/views/activiti/modules/otherModal.vue'
import feedbackModal from '@/views/activiti/modules/feedbackModal.vue'
import InventoryModal from '@/views/activiti/modules/InventoryModal.vue'
import ccChange from '@/components/module/ccChange'
import newPaymentModel from './modules/newPaymentModel.vue'
import quotation from './modules/quotation.vue'
import contractReview from '@/views/activiti/modules/contractReview.vue'
import tender from '@/views/activiti/modules/tender.vue'
import contractDetail from '@/views/projectCollection/contract/contractDetail.vue'
import terminationModal from '@/views/activiti/modules/terminationModal.vue'



import storage from 'store'
const deptMap = {}
export default {
  components: {
    contractDetail,
    tender,
    contractReview,
    quotation,
    salaryEditModal,
    ProcFlowModal,
    BusinessModal,
    LeaveModal,
    PurchaseModal,
    ScrapModal,
    receiveModal,
    OperationModal,
    ServiceModal,
    ReimbursementModal,
    payMentModal,
    contractModal,
    transferModal,
    sealModal,
    currencyModal,
    returnModal,
    carModal,
    returncarModal,
    salaryModal,
    adjustmentModal,
    chargeModal,
    otherModal,
    feedbackModal,
    InventoryModal,
    ccChange,
    newPaymentModel,
    terminationModal
  },
  data() {
    return {
      queryParam: {
        procDefKey: undefined,
        title: '',
        result: '',
        status: '',
        companyId: undefined,
        deptId: undefined,
        applyCode: '',
        amount: '',
        currentTask: '',
      },
      is_revocation: false,
      operTypeMap: {},
      ids: '', //撤销id
      reason: '', //撤销原因
      statusMap: '',
      isRouterAlive: true,
      selectedRowKeysTab: [],
      Approvallist: [],
      selectedRowKeysTabItems: [],
      scroll_y: 150,
      deptMap,
      data: '',
      deptTree: [],
      loading: false,
      name: '', //搜索关键字
      spu_sn: '',
      date: [],
      dates: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showLessItems: true,
        showSizeChanger: true,
      },
      apply_rules: {
        reason: [
          {
            required: true,
            message: '请输入申领原因',
            trigger: 'blur',
          },
        ],
      },
      is_apply_show: false,
      apply_info: {
        cc: [],
        expectDate: '',
        ascriptionDept: undefined,
        itemType: undefined,
        remark: '',
        old_goods: [],
      },
      labelCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 7,
        },
      },
      wrapperCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 16,
        },
      },
      labelCol2: {
        span: 2,
      },
      wrapperCol2: {
        span: 22,
      },
      labelCol3: {
        span: 8,
      },
      wrapperCol3: {
        span: 16,
      },
      options: [],
      checkAll: false,
      indeterminate: false,
      checkAllOptions: [], //全项
      detailsrow: '',
      detailsvisible: false,
      ccC: 'purchase',
      deptlist: [],
    }
  },
  filters: {
    operTypeFilter(type) {
      return operTypeMap[type].text
    },
    deptFilter(type) {
      return deptMap[type].text
    },
  },
  created() {
    this.get_list()
    tree_all().then((res) => {
      if (res.code == 200) {
        this.companylist = res.data[0]
      }
    })
    audit_list().then((res) => {
      this.Approvallist = res.data
    })
    get_dict('goodStatus', (res) => {
      this.statusMap = res
    })
    dict({
      pageNum: 1,
      pageSize: 10,
      dictType: 'assets_type',
    }).then((res) => {
      this.assettype = res.rows
      this.assettype.map((d) => {
        this.operTypeMap[d.dictCode] = {
          text: d.dictLabel,
        }
      })
    })
  },
  mounted() {
    returnDept2((res) => {
      this.options = res.depts
    })
    // get_dept_tree().then((res) => {
    // 	this.companylist = res.data.dept_lis
    // 	this.companylist.unshift({
    // 		dept_id: 0,
    // 		dept_name: '所有公司',
    // 		child_lis: [],
    // 	})
    // })
    this.$nextTick(() => {
      var max_h = $('#content_main_center_scroll').height()
      setTimeout(() => {
        this.scroll_y = max_h - $('.ant-table-header').height() - 50
      }, 1000)
    })
  },
  methods: {
    produce() {
      this.$refs.quotation.init()
    },
    handlecompanyplan(e) {
      this.deptTree = []
      // this.queryParam.deptId = undefined
      this.queryParam.deptId = ''
      this.$nextTick(() => {
        this.companylist.forEach((item) => {
          if (item.value == e) {
            this.deptTree = item.children
          }
        })
        // getDeptListEnable2().then((res) => {
        // 	const data = res.rows
        // 	if (data.length > 0) {
        // 		const min = Math.min(...data.map((m) => m.parentId))
        // 		this.buildtree2(data, this.deptTree, this.form.companyId)
        // 		this.buildtree2(data, this.deptTree, this.allform.companyId)
        // 	}
        // 	// console.log(this.deptTree,'this.deptTree+++++++++++++++++++++++++')
        // })
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    buildtree2(list, arr, parentId) {
      list.forEach((item) => {
        if (item.parentId === parentId) {
          var child = {
            key: item.deptId,
            value: item.deptId, // value是给modal的select用的，2者属性不一样
            title: item.deptName,
            scopedSlots: {
              title: 'title',
            },
            children: [],
          }
          this.buildtree2(list, child.children, item.deptId)
          if (child.children.length === 0) {
            delete child.children
          }
          arr.push(child)
        }
      })
    },
    //切换公司
    // handlecompany(value) {
    // 	this.deptTree = []
    // 	this.queryParam.deptId = ''
    // 	this.$nextTick(() => {
    // 		getDeptListEnable2().then((res) => {
    // 			const data = res.rows
    // 			if (data.length > 0) {
    // 				const min = Math.min(...data.map((m) => m.parentId))
    // 				this.buildtree2(data, this.deptTree, this.queryParam.companyId)
    // 			}
    // 		})
    // 	})
    // },
    delByIds(ids) {
      console.log(ids)
      // const idstr = ids.map(r => { return '\'' + r + '\'' }).join('')
      var _this = this
      this.$confirm({
        title: '是否确认删除?',
        onOk() {
          delBusiness({
            ids: ids.join(','),
          }).then((res) => {
            if (res.code === 200) {
              _this.$message.success('删除成功')
              _this.handleOk()
            } else {
              _this.$message.error(res.msg)
            }
            _this.selectedRowKeys = []
          })
        },
        onCancel() {
          _this.$message.error('你点击了取消')
        },
        class: 'test',
      })
    },
    handFlow(row) {
      var obj = {
        procInstId: row.procInstId,
        procDefKey: row.procDefKey,
      }
      this.$refs.modalflow.show(obj)
    },
    onChange(date, dateString) {
      this.dates = date
      this.queryParam.start_date = date[0]
      this.queryParam.end_date = date[1]
    },
    handelAuditone(record) {
       var fdStart =  record.procDefKey.indexOf("payment-")
				if(fdStart == 0) {
					this.$refs.newPaymentModel.init(record)
				}else {
      const modal = modalMap[record.procDefKey]
      this.$refs[modal].show({
        businessKey: record.id,
        procInstId: record.procInstId,
        procDefKey: record.procDefKey,
        recordNumber: 1,
        tableId: record.tableId,
				result: record.result
      })
        }
    },
    timeChange(date) {
      this.apply_info.expectDate = date
      console.log(this.apply_info.expectDate)
    },
    deletes(row) {
      var index = this.selectedRowKeysTab.indexOf(row.goodsId)
      this.selectedRowKeysTab.splice(index, 1)
      this.selectedRowKeysTabItems.splice(index, 1)
    },
    result() {
      (this.queryParam.procDefKey = undefined),
        (this.queryParam.title = ''),
        (this.queryParam.result = ''),
        (this.queryParam.status = undefined),
        (this.queryParam.companyId = undefined),
        (this.queryParam.deptId = undefined),
        (this.queryParam.applyCode = '')
        this.queryParam.status = ''
        this.queryParam.start_date = ''
        this.queryParam.end_date = ''
        this.queryParam.amount = ''
        this.queryParam.currentTask = ''
        this.dates = []
    },
    // 撤销
    cancel(ids) {
      this.is_revocation = true
      this.ids = ids
      this.reason = ''
    },
    handleOk() {
      this.get_list()
    },
    //撤销提交
    handleOkReason() {
      delProcessIns({
        ids: this.ids.join(','),
        reason: this.reason,
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success('撤销成功')
          this.get_list()
          this.is_revocation = false
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    getdata(data) {
      this.apply_info.cc = data
    },
    //搜索
    serch() {
      this.loading = true
      this.pagination.current = 1
      this.get_list()
    },
    //改变分页
    handleTableChange(pagination, filters, sorter) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.get_list()
    },
    get_list() {
      this.loading = true
      business_list_all({
        pageSize: this.pagination.pageSize,
        pageNum: this.pagination.current,
        status: this.queryParam.status,
        result: this.queryParam.result,
        title: this.queryParam.title,
        procDefKey: this.queryParam.procDefKey,
        startTime: this.queryParam.start_date,
        endTime: this.queryParam.end_date,
        companyId: this.queryParam.companyId,
        deptId: this.queryParam.deptId,
        applyCode: this.queryParam.applyCode,
        amount: this.queryParam.amount,
        currentTask: this.queryParam.currentTask,
      }).then((res) => {
        this.loading = false
        const pagination = {
          ...this.pagination,
        }
        pagination.total = res.total
        this.pagination = pagination
        this.data = res.rows
      })
    },
    //选择第一个表格
    onSelectChangeTab(selectedRowKeys, selectedRows) {
      var arr = JSON.parse(JSON.stringify(selectedRows))
      this.selectedRowKeysTabItems = this.selectedRowKeysTabItems.concat(arr)
      this.selectedRowKeysTab = selectedRowKeys
      var obj = {}
      this.selectedRowKeysTabItems = this.selectedRowKeysTabItems.reduce(function (item, next) {
        obj[next.id] ? '' : (obj[next.id] = true && item.push(next))
        return item
      }, [])
      var newLis = []
      this.selectedRowKeysTab.forEach((key, idx) => {
        this.selectedRowKeysTabItems.forEach((item, index) => {
          if (key == item.id) {
            newLis.push(item)
          }
        })
      })
      this.selectedRowKeysTabItems = newLis
    },
    show_apply() {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
      this.apply_info = {
        cc: [],
        expectDate: '',
        ascriptionDept: undefined,
        itemType: undefined,
        remark: '',
        old_goods: [],
      }
      this.selectedRowKeysTabItems.forEach((item) => {
        item['delivery_amount'] = 1
      })
      this.apply_info.old_goods = this.selectedRowKeysTabItems
      this.is_apply_show = true
    },
    //选择部门
    onChangeDept(value) {
      this.apply_info.cc = []
      this.checkAll = false
      this.apply_info.deptKey = value[1]
      get_users(value[1], (res) => {
        res.forEach((item) => {
          item['label'] = item.userName
          item['value'] = item.userId
        })
        this.checkAllOptions = res
      })
    },
    //全选改变
    onCheckAllChange(e) {
      var vs = []
      this.checkAllOptions.forEach((item) => {
        vs.push(item.value)
      })
      this.apply_info.cc = e.target.checked ? vs : []
      this.indeterminate = false
      this.checkAll = e.target.checked
    },
    // 某项改变
    onChangeFroup(checkedList) {
      this.indeterminate = !!checkedList.length && checkedList.length < this.checkAllOptions.length
      this.checkAll = checkedList.length === this.checkAllOptions.length
    },
    //限制最大值
    set_max_min(row) {
      let max = row.amount
      if (row.delivery_amount < 1) {
        row.delivery_amount = 1
      }
      if (row.delivery_amount > max) {
        row.delivery_amount = max
      }
      this.$forceUpdate()
    },
    //点击领用出库
    apply_delivery: debounce(
      function () {
        var _this = this
        this.$refs.apply_ref.validate((valid) => {
          if (valid) {
            var lis = []
            _this.apply_info.old_goods.forEach((item) => {
              lis.push({
                spuSn: item.spu_sn,
                name: item.name,
                model: item.model,
                isInspected: item.is_inspected,
                price: item.price,
                unit: item.unit,
                usages: item.usages,
                amount: item.delivery_amount,
                spuId: item.id,
                expectDate: _this.apply_info.expectDate,
                itemType: _this.apply_info.itemType,
                ascriptionDept: _this.apply_info.ascriptionDept,
                goodType: 1,
              })
            })
            purchase_save({
              cc: _this.apply_info.cc.length ? _this.apply_info.cc.join(',') : '',
              bizGoodsInfos: lis,
              remark: _this.apply_info.remark,
            }).then((res) => {
              if (res.code != 200) {
                this.$message.error(res.msg)
                return
              }
              this.$message.success('采购成功')
              this.get_list()
              this.is_apply_show = false
            })
          } else {
            console.log('error submit!!')
            return false
          }
        })
      },
      1000,
      {
        leading: true,
        trailing: false,
      }
    ),
    details(row) {
      this.detailsvisible = true
      this.detailsrow = row
    },
  },
}
</script>

<style scoped>
.dialog {
  display: flex;
  justify-content: space-between;
}

.flex {
  display: flex;
}

.center {
  text-align: center;
  width: 832px;
}

.dialog .dialog_item {
  margin-bottom: 5px;
  width: 220px;
  display: flex;
  justify-content: space-between;
}

.Exhi {
  display: inline-block;
  border: 1px solid black;
  width: 100px;
  text-align: left;
  color: steelblue;
}
</style>

